export default __webpack_public_path__ + "static/media/Icon-menu.c142eca0.svg";